import { Link } from "react-router-dom";
import { usd } from "../lib/api";

export default function ListingCard({ listing, index = 0 }) {
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <Link
      to={`/listing/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      onMouseMove={onMove}
      className="spotlight-card group block border border-[#5A2A24] bg-[#2C0D12] hover:border-[#7A4033] transition-colors"
    >
      <div className="relative aspect-[4/3] overflow-hidden hud-frame">
        <img src={listing.image} alt={listing.title}
             className="w-full h-full object-cover grayscale-[0.2] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1E070A] via-transparent to-transparent" />
        <span className="hud-corner tl opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="hud-corner tr opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="hud-corner bl opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="hud-corner br opacity-0 group-hover:opacity-100 transition-opacity" />
        <div className="absolute top-3 left-3 mono-label bg-[#1E070A]/80 px-2 py-1 backdrop-blur-sm z-[6]">
          {String(index + 1).padStart(2, "0")} / {listing.category}
        </div>
        {listing.status === "reserved" && (
          <div className="absolute top-3 right-3 mono-label bg-[#C0894F] text-white px-2 py-1 z-[6]">RESERVED</div>
        )}
        <div className="absolute bottom-3 left-3 z-[6] font-mono text-[0.6rem] tracking-widest text-[#9DB562] bg-[#1E070A]/70 px-2 py-0.5 opacity-0 group-hover:opacity-100 transition-opacity">● IN RANGE</div>
      </div>
      <div className="p-5 relative z-[3]">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="mono-label mb-1">{listing.manufacturer}</div>
            <h3 className="font-display text-xl leading-tight uppercase">{listing.title}</h3>
          </div>
          <div className="font-mono text-[#C0894F] text-lg whitespace-nowrap">{usd(listing.price)}</div>
        </div>
        <div className="mt-4 flex items-center gap-4 text-xs font-mono text-[#8C6552]">
          <span>{listing.caliber}</span>
          <span className="w-1 h-1 bg-[#8C6552] rounded-full" />
          <span>{listing.condition}</span>
        </div>
      </div>
    </Link>
  );
}
